import React from 'react';

const Footer = () => {
    return (
        <footer>
            <h1>&copy; Maystrodons 2021</h1>
            <p>
                Coded with <i className="fas fa-heart" style={{color: "red"}}/> by
                <a href="https://uzor.codes"> Uzor</a>
            </p>
        </footer>
    );
};

export default Footer;
